import dayjs from 'dayjs';

export type TimeFormat = 'HH:mm:ss' | 'HH:mm:ss.SSS' | 'HH:mm:ss z';

/**
 * Millisec-et alakít olvasható formára, pl. 230000 -> 00:03:50
 **/
export function msToTime(value: number, showMs = false): string {
  const s = Math.floor(value / 1000) % 60;
  const m = Math.floor(value / 60000) % 60;
  const h = Math.floor(value / 3600000);

  const result = `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;

  if (!showMs) return result;

  const ms = value % 1000;
  return `${result}.${ms.toString().padStart(1, '0')}`;
}

/**
 * Mint az msToTime, csak nem tölti fel 0-val a nagyobb léptékeket: pl. 230000 -> 03:50
 */
export function msToTimeMinimal(value: number, roundMs = true): string {
  if (value === 0) return '0';

  const absValue = Math.abs(value);
  const msRaw = roundMs ? (absValue % 1000) / 100 : absValue % 1000;
  const sign = value < 0 ? '-' : '';

  const ms = Math.round(msRaw);
  const s = Math.floor(absValue / 1000) % 60;
  const m = Math.floor(absValue / 60000) % 60;
  const h = Math.floor(absValue / 3600000);

  const msString = ms === 0 ? '' : `.${ms}`;
  const sString = absValue < 10000 ? s.toString() : `${s.toString().padStart(2, '0')}`;

  if (absValue < 60000) {
    return `${sign}${sString}${msString}`;
  } else if (absValue < 3600000) {
    return `${sign}${m.toString().padStart(2, '0')}:${sString}${msString}`;
  }

  return `${sign}${h}:${m.toString().padStart(2, '0')}:${sString}${msString}`;
}

/** UTC időponthoz ms delta hozzáadása. */
function addDelta(isoUtc: string, deltaMs: number): dayjs.Dayjs {
  return dayjs.utc(isoUtc).add(deltaMs, 'millisecond');
}

/** Időpont megjelenítése a zónában: HH:mm:ss[.SSS] */
function formatTimeInZone(instant: dayjs.Dayjs, zone: string, format: TimeFormat = 'HH:mm:ss'): string {
  return instant.tz(zone).format(format);
}

/** UTC időhöz delta ms hozzáadása, zónában visszaadva. */
export function addDeltaToTimeInZone(
  isoUtc: string,
  deltaMs: number,
  zone: string,
  format: TimeFormat = 'HH:mm:ss',
): string {
  return formatTimeInZone(addDelta(isoUtc, deltaMs), zone, format);
}
